import { get as _get } from 'lodash-es';

// Store
import store from '@/store';
import { MUTATION, ACTION } from '@/store/CONSTANTS';

// Route names
import {
  DEALS as DEALS_ROUTE_NAMES,
  SLIDES as SLIDES_ROUTE_NAMES,
} from '@/router/wizard/ROUTE_NAMES';

// Views
import WizardView from '@/views/WizardView.vue';
import Deals from '@/views/wizard/Deals.vue';
import SlideItem from '@/views/wizard/SlideItem.vue';

// Children routes
import dealsChildren from '@/router/wizard/deals/routes';
import slidesChildren from '@/router/wizard/slides';

export const wizardChildrenRoutes = [
  {
    path: '',
    redirect: { name: DEALS_ROUTE_NAMES.INDEX },
  },
  {
    path: 'deals',
    component: Deals,
    redirect: { name: DEALS_ROUTE_NAMES.INDEX },
    children: dealsChildren,
  },
  {
    path: 'deal/:dealUid',
    name: SLIDES_ROUTE_NAMES.INDEX,
    component: SlideItem,
    children: slidesChildren,
    async beforeEnter(to, _from, next) {
      const { dealUid } = to.params;
      let deal = store.state.wizard.deals.find(({ uid }) => uid === dealUid);

      if (!deal?.qualities) {
        try {
          store.commit('setLoading', true);
          deal = await store.dispatch(ACTION.WIZARD.FETCH_SINGLE_DEAL, dealUid);
          store.commit('setLoading', false);
        } catch {
          store.commit('setLoading', false);
          if (!deal) return next({ name: DEALS_ROUTE_NAMES.INDEX });
        }
      }

      if (dealUid !== _get(store.state, 'wizard.currentDeal.uid')) {
        if (store.state.wizard.unsavedDeals[dealUid]) {
          store.commit(MUTATION.WIZARD.CURRENT_DEAL.SET, store.state.wizard.unsavedDeals[dealUid]);
        } else {
          store.commit(MUTATION.WIZARD.CURRENT_DEAL.SET, deal);
        }
      }

      return next();
    },
  },
];

export default [
  {
    path: '/wizard',
    component: WizardView,
    children: wizardChildrenRoutes,
    meta: {
      authOnly: true,
    },
  },
];
